<div arcSharedUserActive>
  <aur-loading-spinner class="spinner" *ngIf="showBlockUILoading"></aur-loading-spinner>
  <div class="backdrop" *ngIf="showBackDrop"></div>

  <div class="layout-wrapper">
    <div #layoutContainer class="layout-container menu-layout-static menu-layout-horizontal">
      <application-navigation 
        *ngIf="navVisible$ | async"
        (profileView)="gotoProfile()"
        (tenantSwitchToggle)="toggleSwitchTenant()"
        (logout)="logout()">
      </application-navigation>

      <div [ngClass]="{ 'layout-main': isloggedin$ | async }">
        <div class="layout-content">
          <router-outlet id="arcMainContent"></router-outlet>
        </div>
      </div>
      <div *ngIf="isloggedin$ | async" class="layout-mask"></div>
    </div>
  </div>

  <aur-drawer [dismissible]="true" [(visible)]="showTenantSwitcher" (closeEnd)="switcherDismissed($event)"
    *ngIf="hasMultipleTenants$ | async" [showCloseIcon]="false" size="sm">
    <header>
      <h2>
        {{
        'ARC_SHARED_COMPONENTS_PRESENTATION_TENANT_SWITCHER_POPUP_HEADER'
        | translate
        }}
      </h2>
    </header>
    <arc-shared-tenantswitchercontainer (cancel)="toggleSwitchTenantByButton(false)"
      (ok)="toggleSwitchTenantByButton(true)" [visible]="showTenantSwitcher"></arc-shared-tenantswitchercontainer>
  </aur-drawer>

  <arc-shared-sessionwarning *ngIf="showSessionTimeOut$ | async"></arc-shared-sessionwarning>
</div>

<router-outlet name="drawer"></router-outlet>